export function applyCartFragments(fragments) {
	for (const fragmentKey in fragments) {
		const fragment = document.querySelector(`[data-fragment="${fragmentKey}"]`)

		if (fragment) {
			fragment.outerHTML = fragments[fragmentKey]
		}
	}
}
